import { Sizes } from "../sizes-entity";
import { SizesDto } from "./sizes-dto";

export class SizesAdapter {
    convertDtoToEntity(dtoObj: SizesDto,  isUpdate: boolean = false ): Sizes {
        try {
            const entityObj = new Sizes();
            entityObj.sizeId = dtoObj.sizeId;
            entityObj.sizeName = dtoObj.sizeName;
            entityObj.itemCategoryId = dtoObj.itemCategoryId;
            entityObj.itemSubCategoryId = dtoObj.itemSubCategoryId;
            entityObj.itemId = dtoObj.itemId;
            entityObj.isActive=dtoObj.isActive==undefined?true:dtoObj.isActive; 
            if (isUpdate){
                entityObj.updatedUser = dtoObj.updatedUser;
            }else {
                entityObj.isActive = true;
                entityObj.createdUser = dtoObj.createdUser;
            }
            return entityObj;
        } catch (Error) {
            return Error;
        }
    }

    public convertEntityToDto(sizeObject: Sizes): SizesDto {
        const sizeDTO= new SizesDto;
        sizeDTO.sizeId = sizeObject.sizeId;
        sizeDTO.sizeName = sizeObject.sizeName;
        sizeDTO.itemCategoryId = sizeObject.itemCategoryId;
        sizeDTO.itemSubCategoryId = sizeObject.itemSubCategoryId;
        sizeDTO.itemId = sizeObject.itemId;
        sizeDTO.isActive = sizeObject.isActive;
        sizeDTO.createdAt = sizeObject.createdAt;
        sizeDTO.updatedAt = sizeObject.updatedAt;
        sizeDTO.createdUser = sizeObject.createdUser;
        sizeDTO.updatedUser = sizeObject.updatedUser;
        sizeDTO.versionFlag = sizeObject.versionFlag;
        return sizeDTO;
      }
}